import { useLogin } from './hooks/useAuth'
import AuthCard from 'components/auth/AuthCard'
import SignInForm from './components/SignInForm'

function SignIn() {
  const { loading, errorMessage, onSubmit } = useLogin()

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <AuthCard>
        <AuthCard.Header
          title="SawitPRO"
          subtitle="Masuk ke Admin Web"
          image="/media/logoSawitpro.png"
        />

        <AuthCard.Body>
          <SignInForm loading={loading} errorMessage={errorMessage} onSubmit={onSubmit} />
        </AuthCard.Body>
      </AuthCard>
    </div>
  )
}

export default SignIn
